import React from 'react';
import {
  Box,
  Flex,
  Container,
  Image,
  Text,
  VStack,
  HStack,
  Button } from
'@chakra-ui/react';
import {
  Routes,
  Route,
  Link as RouterLink,
  useNavigate } from
'react-router-dom';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ComparisonSection } from './components/ComparisonSection';
import { SolutionSection } from './components/SolutionSection';
import { ProofSection } from './components/ProofSection';
import { FinalCTA } from './components/FinalCTA';
// import { ReportPage } from './pages/ReportPage';
// import { LoginPage } from './pages/LoginPage';
// import { SignupPage } from './pages/SignupPage';
// import { DashboardPage } from './pages/DashboardPage';
import { RadarLandingPage } from './pages/RadarLandingPage';
import { RequestAccessPage } from './pages/RequestAccessPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LogOut, LayoutDashboard } from 'lucide-react';
function ScannerLandingPage() {
  return (
    <Box as="main">
      <Hero />
      <ProblemSection />
      <ComparisonSection />
      <SolutionSection />
      <ProofSection />
      <FinalCTA />
    </Box>);

}
function Header() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
 
  return (
    <Box
      as="header"
      borderBottom="1px solid"
      borderColor="rgba(30, 58, 40, 0.5)"
      bg="rgba(13, 26, 18, 0.8)"
      backdropFilter="blur(12px)"
      position="sticky"
      top={0}
      zIndex={50}>
      
      <Container maxW="container.xl" px={4}>
        <Flex h="64px" align="center" justify="space-between">
          <Box as={RouterLink} to="/" display="flex" alignItems="center">
            <Image
              src="/gmc-radar-logo.svg"
              alt="GMCRadar"
              h="32px" />
            
          </Box>

          <Flex align="center" gap={4}>
        <Box
  as="a"
  href="https://app.gmcradar.com"
  fontSize="sm"
  fontWeight="semibold"
  color="white"
  _hover={{
    color: 'brand.green'
  }}
  transition="colors 0.2s"
>
  Login
</Box>
          </Flex>
        </Flex>
      </Container>
    </Box>);

}
export function App() {
  return (
    <AuthProvider>
      <Flex direction="column" minH="100vh" bg="brand.dark" color="white">
        <Header />

        <Box flex="1">
          <Routes>
            <Route path="/" element={<RadarLandingPage />} />
            <Route path="/lander" element={<ScannerLandingPage />} />
            {/* <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/report/:id" element={<ReportPage />} /> */}
            <Route path="/request-access" element={<RequestAccessPage />} />
            <Route
              path="/policies/terms-of-service"
              element={<TermsOfServicePage />} />
            
            <Route
              path="/policies/privacy-policy"
              element={<PrivacyPolicyPage />} />
            
          </Routes>
        </Box>

        {/* Shared Footer */}
        <Box
          as="footer"
          borderTop="1px solid"
          borderColor="brand.border"
          bg="brand.card"
          py={10}
          mt="auto">
          
          <Container maxW="container.xl" px={4}>
            <Flex
              direction={{
                base: 'column',
                md: 'row'
              }}
              align="flex-start"
              justify="space-between"
              gap={8}>
              
              <Box>
                <Image
                  src="/gmc-radar-logo.svg"
                  alt="GMCRadar"
                  h="28px" />
                
              </Box>

              <Flex
                direction={{
                  base: 'column',
                  sm: 'row'
                }}
                gap={{
                  base: 8,
                  sm: 16
                }}>
                
                <VStack align="flex-start" spacing={3}>
                  <Text
                    fontSize="xs"
                    fontWeight="bold"
                    color="gray.500"
                    textTransform="uppercase"
                    letterSpacing="wider">
                    
                    Navigate
                  </Text>
                  <VStack align="flex-start" spacing={2}>
                    <Box
                      as={RouterLink}
                      to="/"
                      onClick={() => window.scrollTo(0, 0)}
                      fontSize="sm"
                      color="gray.400"
                      _hover={{
                        color: 'white'
                      }}
                      transition="colors 0.2s">

                      Homepage
                    </Box>
                    <Box
                      as={RouterLink}
                      to="/request-access"
                      onClick={() => window.scrollTo(0, 0)}
                      fontSize="sm"
                      color="gray.400"
                      _hover={{
                        color: 'white'
                      }}
                      transition="colors 0.2s">

                      Request Access
                    </Box>
                    {/* <Box
                      as={RouterLink}
                      to="/lander"
                      onClick={() => window.scrollTo(0, 0)}
                      fontSize="sm"
                      color="gray.400"
                      _hover={{
                        color: 'white'
                      }}
                      transition="colors 0.2s">
                      
                      Scan My Store
                    </Box> */}
                  </VStack>
                </VStack>

                <VStack align="flex-start" spacing={3}>
                  <Text
                    fontSize="xs"
                    fontWeight="bold"
                    color="gray.500"
                    textTransform="uppercase"
                    letterSpacing="wider">
                    
                    Legal
                  </Text>
                  <VStack align="flex-start" spacing={2}>
                    <Box
                      as={RouterLink}
                      to="/policies/terms-of-service"
                      onClick={() => window.scrollTo(0, 0)}
                      fontSize="sm"
                      color="gray.400"
                      _hover={{
                        color: 'white'
                      }}
                      transition="colors 0.2s">

                      Terms of Service
                    </Box>
                    <Box
                      as={RouterLink}
                      to="/policies/privacy-policy"
                      onClick={() => window.scrollTo(0, 0)}
                      fontSize="sm"
                      color="gray.400"
                      _hover={{
                        color: 'white'
                      }}
                      transition="colors 0.2s">

                      Privacy Policy
                    </Box>
                  </VStack>
                </VStack>
              </Flex>
            </Flex>

            <Box
              borderTop="1px solid"
              borderColor="brand.border"
              mt={8}
              pt={6}
              textAlign="center">
              
              <Text color="gray.500" fontSize="sm">
                © {new Date().getFullYear()} GMCRadar. All rights reserved.
              </Text>
            </Box>
          </Container>
        </Box>
      </Flex>
    </AuthProvider>);

}
